export function isDevelopment() { return ['dev', 'stg'].includes(process.env.ENV) }
